import { Checkbox } from "antd";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { useSticky } from "react-table-sticky";
import { toast, ToastContainer } from "react-toastify";
// import CheckBox from "./ReactTableFiles/CheckBox";
// import ColumnFilter from "./ReactTableFiles/ColumnFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import { TextField, Tooltip } from "@mui/material";
import { common_axios } from "../../../../App";
import CheckBox from "../../Reacttable/UserManagement/ReactTableFiles/CheckBox";
import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import Backdrop from "@mui/material/Backdrop";
import Loader from "../../../../components/Loader";
import TableViewIcon from "@mui/icons-material/TableView";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import { dateFormatter } from "../../../../helper/helper";
import CancelIcon from "@mui/icons-material/Cancel";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import * as React from "react";
import Pagination from "@mui/material/Pagination";
import {
  Stack,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextareaAutosize,
  InputAdornment,
} from "@mui/material";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import RefreshIcon from "@mui/icons-material/Refresh";
import { mainSkelton,runninglist,schedulelist,stoppedlist,processlist,} from "../../../../redux/features/pageSlices";
import { useDispatch } from "react-redux";
import InfoIcon from "@mui/icons-material/Info";
export default function Schedule({ stoppedArray, open: open1, }) {


 // .....................................................Scroll Bar.................................................................//
 const wrapper1Ref = useRef(null);
 const wrapper2Ref = useRef(null);
 const div1Ref = useRef(null);
 const div2Ref = useRef(null);

 const handleWrapper1Scroll = (e) => {
   wrapper2Ref.current.scrollLeft = wrapper1Ref.current.scrollLeft;
 };

 const handleWrapper2Scroll = (e) => {
   wrapper1Ref.current.scrollLeft = wrapper2Ref.current.scrollLeft;
 };

 const updateDivWidths = () => {
  //  if (div1Ref.current && div2Ref.current) {
  //    div1Ref.current.style.width =
  //      div2Ref.current.querySelector("table").offsetWidth + "px";
  //    div2Ref.current.style.width =
  //      div2Ref.current.querySelector("table").offsetWidth + "px";
  //  }
 };

 // ..................................................End Of Scroll Bar..............................................................//





  const [open, setOpen] = useState();
  const [scheduledata, setScheduleData] = useState([]);
  const [paginationPage, setPaginationPage] = React.useState(1);
  const [ScheduleTotalCount, setScheduleTotalCount] = useState();
  const [hideSkeleton, sethideSkeleton] = useState();
  const [data1, setData1] = useState([]);
  const [stoppedFun, setStoppedFun] = useState(true);
  const customId1 = "custom-id-yess";
  const [stoppedFunState, setStoppedFunState] = useState();
  const [TableStatus, setTableStatus] = useState({
    pageNo: 0,
    pageSize: 10,
  });
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  // console.log("totalPage----", ScheduleTotalCount);
  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const [viewDetails, setViewDetails] = useState(undefined);
 
  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);

  const approveUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
    await modelButtonApprove.current.click();
  };

  const rejectUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetail(cell.row.original);
    await modelButtonReject.current.click();
  };
  const viewRefModal = useRef(null);

  const veiwModal = async (cell) => {
    await setViewDetails(cell.row.original);
    await viewRefModal.current.click();
  };
  useEffect(() => {
    if (stoppedArray?.content && stoppedArray?.content.length > 0) {
      setData(stoppedArray?.content);
      setData1(stoppedArray);
    } else {
      setData([]);
    }
    // setTotalPage(stoppedArray?.totalPages);
    // settotalPageCount(stoppedArray?.pageable?.pageNumber);
  }, [stoppedArray]);

  useEffect(() => {
    setStoppedFunState(stoppedFun);
  }, [stoppedFun]);

  // ...........................Rfresh API....................//
  async function RefreshBtn(values) {
    // setTableLoader(true);
    sethideSkeleton(true);
    dispatch(mainSkelton(true));
    try {
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/campaign/schedule/status`,
        {
          pageNo: TableStatus?.pageNo,
          pageSize: TableStatus?.pageSize,
        }
      );
      // console.log("------resultssss", result);
      if (result.data.statusDescription.statusCode == 200) {
        sethideSkeleton(false);
        //  setData(result.data.stoppedList.content);
        await setData1(result.data?.stoppedList);

        // await setTotalPage(result.data.scheduledList.totalPages);
        // await settotalPageCount(result.data.scheduledList.pageable.pageNumber);
        await setScheduleTotalCount(result.data.scheduledList.totalElements);

        dispatch(mainSkelton(false));
        dispatch(schedulelist(result?.data?.scheduledList));
        dispatch(runninglist(result?.data?.running));
        dispatch(stoppedlist(result?.data?.stoppedList));
        dispatch(processlist(result?.data?.createdCampaign));

        // await toast.success("success", {
        //   theme: "colored",
        //   toastId: customId1,
        // });
      }  else if (result.data?.statusDescription?.statusCode == 220) {
        // alert("here");
        dispatch(mainSkelton(false));
        setScheduleTotalCount(null);
        dispatch(schedulelist([]));
        dispatch(runninglist([]));
        dispatch(stoppedlist([]));
        dispatch(processlist([]));
       
      } else {
        sethideSkeleton(false);
        dispatch(mainSkelton(false));
        Swal.fire({
          icon: "error",
           title: "Oops...",
          text:result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      //   console.log(error);
      sethideSkeleton(false);
      dispatch(mainSkelton(false));

      Swal.fire({
        icon: "error",
         title: "Oops...",
        text:"Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
    // console.log("response..", res);
  }
  // ...........................Status API....................//
  async function StopPost(values) {
    // setTableLoader(true);
    setOpen(true);
    try {
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/campaign/schedule/status`,
        {
          pageNo: TableStatus?.pageNo,
          pageSize: TableStatus?.pageSize,
        }
      );
      // console.log("ret", result.data.stoppedList);
      if (result.data.statusDescription.statusCode == 200) {
        setOpen(false);
        setData(result.data.stoppedList.content);
        await setData1(result.data?.stoppedList);

        // await setTotalPage(result.data.stoppedList.totalPages);
        // await settotalPageCount(result.data.stoppedList.pageable.pageNumber);
        await setScheduleTotalCount(result.data.stoppedList.totalElements);
        // await toast.success("success", {
        //   theme: "colored",
        //   toastId: customId1,
        // });
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
           title: "Oops...",
          text:result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      //   console.log(error);
      setOpen(false);
      Swal.fire({
        icon: "error",
         title: "Oops...",
        text:"Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
    // console.log("response..", res);
  }

  const columns = useMemo(
    () => [
      {
        Header:"Id",
        accessor: "id",
        Cell: (cell) => {
          // console.log("cell--", cell.row.index);
          return (
            <>
              {cell.row.index +
                1 +
                TableStatus?.pageNo * TableStatus?.pageSize}
            </>
          );
        },
      },
      {
        Header: "Campaign name",

        accessor: "eventName",
      },
      {
        Header: "Start Date",

        accessor: "datetimeScheduled", // accessor is the "key" in the data
        Cell: (cell) => {
          return (
            <>
              <div>{cell?.row?.original?.datetimeScheduled?.split(' ')?.map((dataaa)=>{
                return (
                  <>
                  <span style={{whiteSpace:'nowrap',}}>{dataaa}</span>
                  <br/>
                  </>
                )
              })}</div>
            </>
          );
        },
      },
      {
        Header: "End Date Time",

        accessor: "datetimeEnd", // accessor is the "key" in the data
        Cell: (cell) => {
          return (
            <>
              <div>{cell?.row?.original?.datetimeEnd?.split(' ')?.map((dataaa)=>{
                return (
                  <>
                  <span>{dataaa}</span>
                  <br/>
                  </>
                )
              })}</div>
            </>
          );
        },
      },
      {
        Header: "Sender Id",

        accessor: "senderId", // accessor is the "key" in the data
      },
    
      // {
      //   Header: "Camp Type",

      //   accessor: "campaignType", // accessor is the "key" in the data
      // },
      {
        Header: "Total sms",

        accessor: "smsCount", // accessor is the "key" in the data
        Cell: (cell) => {
          return (
            <>
             {cell.row.original.smsCount?.toLocaleString('en-US')}
            </>
          );
        },
      },
 
    
      {
        Header: "Sent",

        accessor: "proccesed", // accessor is the "key" in the data
        Cell: (cell) => {
          return (
            <>
             {cell.row.original.proccesed?.toLocaleString('en-US')}
            </>
          );
        },
      },
      {
        Header: "Delivered",

        accessor: "deliverd", // accessor is the "key" in the data
        Cell: (cell) => {
          return (
            <>
             {cell.row.original.deliverd?.toLocaleString('en-US')}
            </>
          );
        },
      },
      {
        Header: "Camp Type",

        accessor: "campaignType", // accessor is the "key" in the data
        Cell: (cell) => {
          return (
            <>
              {cell?.row?.original?.campaignType == "Promotional "  ? (
                <div className=""  >
                 P
                </div>
              ) : (
                <div className=""
                
                >
                 T
                </div>
              )}
            </>
          );
        },
      },
      // {
      //   Header: "SMS sent count",

      //   accessor: "smsCount", // accessor is the "key" in the data
      // },
      {
        Header: "Message",
        accessor: "message", // accessor is the "key" in the data
        Cell: (cell) => {
          return (
            <>
              {cell.row.original.message.length >= 60 ? (
                <div className="">
                  <div className="showMoreTd">
                    {cell.row.original?.[`Show`]
                      ? cell.row.original.message?.slice(0, 60) + "..."
                      : cell.row.original.message}
                  </div>
                  <button
                    className="showMore"
                    onClick={() => {
                      // Showdata?.[`Show${cell.row.index}`];

                      const dataaa = [...data];

                      dataaa[cell.row.index][`Show`] =
                        !cell.row.original?.[`Show`];

                      setData(dataaa);
                    }}
                  >
                    {cell.row.original?.[`Show`] ? "More" : "Less"}
                  </button>
                </div>
              ) : (
                <div className="showMoreTd">{cell.row.original.message}</div>
              )}
            </>
          );
        },
      },
      {
        Header: "Status",

        accessor: "status",
        Cell: (cell) => {
          return (
            <>
              {cell.row.original.scheduledStatus == 5 ? (
                <div className="badge badge_8 bg-danger">Stopped</div>
              ) : (
                <div className="badge badge_8 bg-danger">Unscheduled</div>
              )}
            </>
          );
        },
      },

      {
        Header: "Action",
        Footer: "Action",
        accessor: "action",
        Cell: (cell) => (
          <div className="dropdown">
            <button
              className="btn color_1 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="material-icons opacity-10 size">person</i>
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              {/* {cell.row.original.approved != 1 && ( */}
              <li
                onClick={() => {
                  // console.log(cell);
                }}
              >
                <a
                  className="dropdown-item"
                  onClick={() => {
                    veiwModal(cell);
                  }}
                >
                  View Details
                </a>
              </li>
              {/* // )} */}
            </ul>
          </div>
        ),

        disableFilters: true,
      },
    ],
    [TableStatus, data]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
    // useColumnOrder,
    // useBlockLayout,
    // useSticky,
    // (hooks) => {
    //   hooks.visibleColumns.push((columns) => {
    //     return [
    //       {
    //         id: "selection",
    //         Header: ({ getToggleAllRowsSelectedProps }) => (
    //           <CheckBox {...getToggleAllRowsSelectedProps()} />
    //         ),
    //         Cell: ({ row }) => (
    //           <CheckBox {...row.getToggleRowSelectedProps()} />
    //         ),
    //       },
    //       ...columns,
    //     ];
    //   });
    // }
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };

  useEffect(() => {
    // if (TableStatus?.pageNo != 0 || TableStatus?.pageSize != 10) {
    //   // StopPost();
    // }
    if (stoppedFunState == false) {
      StopPost();
    }
  }, [TableStatus.pageSize, TableStatus.pageNo]);


 // ..........................................ScrollBar Useefffect.......................
 useEffect(() => {
  if (wrapper1Ref.current && wrapper2Ref.current) {
    wrapper1Ref.current.addEventListener("scroll", handleWrapper1Scroll);
    wrapper2Ref.current.addEventListener("scroll", handleWrapper2Scroll);
  }
  updateDivWidths();
  window.addEventListener("resize", updateDivWidths);
  return () => {
    window.removeEventListener("resize", updateDivWidths);
  };
}, [wrapper1Ref, wrapper2Ref, div1Ref, div2Ref, data]);

// ............................................End.........................//




  return (
    <div>
      <div>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Loader />
        </Backdrop>
      </div>

      {/* {viewDetails != undefined && ( */}
        <div>
          <button
            ref={viewRefModal}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop10"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop10"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdrop10Label"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdrop10Label">
                    View Details
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <label for="exampleInputEmail1" className="form-label">
                        Event Name:
                      </label>
                      <input
                        disabled
                        type="text"
                        value={viewDetails?.eventName}
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                    <div className="col-md-6 mt_2">
                      <label for="exampleInputEmail1" className="form-label">
                        Scheduled Date :
                      </label>
                      <input
                        disabled
                        type="text"
                        value={dateFormatter(viewDetails?.datetimeScheduled)}
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-6">
                      <label for="exampleInputEmail1" className="form-label">
                        Sender-Id:
                      </label>
                      <input
                        disabled
                        type="text"
                        value={viewDetails?.senderId}
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                    <div className="col-md-6">
                      <label for="exampleInputEmail1" className="form-label">
                        Id:
                      </label>
                      <input
                        disabled
                        className="form-control"
                        placeholder="Sender Id Here"
                        type="text"
                        minLength="3"
                        value={viewDetails?.uid}
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-6">
                      <label for="exampleInputEmail1" className="form-label">
                        Campaign-Type
                      </label>
                      <input
                        disabled
                        type="text"
                        value={viewDetails?.campaignType}
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                    <div className="col-md-6">
                      <label for="exampleInputEmail1" className="form-label">
                        Sms-Type:
                      </label>
                      <input
                        disabled
                        className="form-control"
                        placeholder="Sender Id Here"
                        type="text"
                        minLength="3"
                        value={viewDetails?.smsType}
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-6">
                      <label for="exampleInputEmail1" className="form-label">
                        Status:
                      </label>
                      <input
                        disabled
                        type="text"
                        value={viewDetails?.status}
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                    <div className="col-md-6">
                      <label for="exampleInputEmail1" className="form-label">
                        Unicode:
                      </label>
                      <input
                        disabled
                        className="form-control"
                        type="text"
                        minLength="3"
                        value={viewDetails?.unicode == 0 ? "False" : "True"}
                      />
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-md-12">
                      <label for="exampleInputEmail1" className="form-label">
                        Message:
                      </label>
                      <TextareaAutosize
                        value={viewDetails?.message}
                        id="textareaid"
                        disabled
                        name="message"
                        fullWidth
                        aria-label="minimum height"
                        minRows={5}
                        className="w-100"
                        placeholder="Message Here"
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer justify-content-between">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      {/* )} */}

      {data?.length > 0 ? (
        <>
          <div className="card-body">
            <div className="card shadow-none border bg_blue mt-4">
              <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                {/* Add Number */}
                Stopped
              </span>
              {hideSkeleton == true ? (
                <>
                  <Box sx={{ width: "100%" }}>
                    <Skeleton />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    {/* <Skeleton animation={false} /> */}
                  </Box>
                </>
              ) : (
                <>
                

                  <div class="card-body">
                    <div className="d-flex justify-content-between mb-3">
                      <select
                        value={TableStatus.pageSize}
                        className="dropdown"
                        onChange={(e) => {
                          setPageSize(Number(e.target.value));
                          setTableStatus({
                            ...TableStatus,
                            pageSize: e.target.value,
                            pageNo:0

                          });
                          setStoppedFunState(false)
                          setPaginationPage(1)
                        }}
                      >
                        {[10, 25, 50].map((value, i) => {
                          return (
                            <option
                              className="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                              value={value}
                              key={value}
                            >
                              Show {value}
                            </option>
                          );
                        })}
                      </select>
                      <Tooltip title="Refresh">
                  <button
                    type="submit"
                    className="btn bg-gradient-primary w_btn m-0 ms-3 me-3 search_1  "
                    // onClick={RefreshBtn}
                    onClick={() => RefreshBtn("Text to Copy")}
                  >
                    {/* <i class="material-icons opacity-10">refresh</i> */}
                    <RefreshIcon />
                  </button>
                </Tooltip>
                     
                      {/* <div className="d-flex align-items-center">

                    <TextField
                      className="ms-4 w-100"
                      style={{
                        borderRadius: "4px",
                      }}
                      type="text"
                      label="Search"
                      name="Search"
                      variant="outlined"
                      // value={number}
                      size="small"
                      value={globalSearchValue || ""}
                      onChange={(e) => {
                        onChange(e.target.value);
                        setGlobalSearchValue(e.target.value);
                      }}
                    />
                  </div> */}
                    </div>

                    <div>
                      {selectedFlatRows.length > 0 && (
                        <button onClick={deletUser}>Delete Users</button>
                      )}

                      {/* <button onClick={changeOrder}>Change Order</button> */}
                    </div>
                    <div className="table-responsive">


                    {/* <div class="wrapper1" ref={wrapper1Ref}>
                        <div class="div1" ref={div1Ref}>
                        <table
                        {...getTableProps()}
                        id="example"
                        className="table table-striped message_table table-bordered dataTable table-sm"
                        style={{ width: "100%" }}
                      >
                        <thead className="teble_scroll2">
                          {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                              {headerGroup.headers.map((column) => (
                                <th
                                  {...column.getHeaderProps(
                                    column.getSortByToggleProps()
                                  )}
                                  className="text-center width_2 update_td"
                                >
                                  {column.render("Header")}
                                  <span>
                                    {column.isSorted
                                      ? column.isSortedDesc
                                        ? "↑"
                                        : "↓"
                                      : ""}
                                  </span>

                             
                                </th>
                              ))}
                            </tr>
                          ))}
                        </thead>
                        <tbody {...getTableBodyProps()} id="svg_tbody">
                        
                          {page.map((row) => {
                            prepareRow(row);
                            return (
                              <tr {...row.getRowProps()}>
                                {row.cells.map((cell) => {
                                  return (
                                    <td
                                      {...cell.getCellProps()}
                                      className={
                                  (cell.column.Header == "SMS count" ||
                                    cell.column.Header == "Sender Id"  ) ?
                                  "text-end update_td" 
                                  :
                                  (cell.column.Header=="Action" ||
                                  cell.column.Header=="Unicode" ||
                                   cell.column.Header=="Status") ?
                                   "text-center update_td":
                                  "text-start update_td"
                                }    
                                    >
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            );
                          })}
                        </tbody>
                    
                      </table>
                        </div>
                      </div> */}
                      {/* <div class="wrapper2" ref={wrapper2Ref}>
                        <div class="div2" ref={div2Ref}> */}
                        <table
                        {...getTableProps()}
                        id="example"
                        className="table table-striped message_table table-bordered dataTable table-sm"
                        style={{ width: "100%" }}
                      >
                        <thead>
                          {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                              {headerGroup.headers.map((column) => (
                                <th
                                  {...column.getHeaderProps(
                                    column.getSortByToggleProps()
                                  )}
                                 className={
                                        column?.Header=="Message" ? "text-center width_2 update_th messageWidth" :
                                        column?.Header=="Camp Type" ?
                                         "text-center width_2 update_th_sp d-flex" :  "text-center width_2 update_th_sp"
                                      }
                                >
                                  {column.render("Header")}
                                  <span>
                                    {column.isSorted
                                      ? column.isSortedDesc
                                        ? "↑"
                                        : "↓"
                                      : ""}
                                  </span>
                                  {
                                          column.Header=="Camp Type" ? (<>
                                            <InputAdornment position="end" className="my-auto">
                                            <Tooltip
                                                title={
                                                ( "P-Promotional T-Transactional").split(" ").map((arg)=>{

                                                  return(<>
                                                    {
                                                      arg
                                                    }
                                                    <br/>
                                                  </>)
                                                 })
                                                  
                                                  }
                                               id="toolTipId"
                                              placement="top"
                                              arrow
                                              sx={{ color: "white" }}
                                            >
                                              <InfoIcon />
                                            </Tooltip>
                                          </InputAdornment>
                                          </>):(<></>)
                                        }
                                  {/* <div>{column.canFilter ? column.render("Filter") : null}</div> */}
                                </th>
                              ))}
                            </tr>
                          ))}
                        </thead>
                        <tbody class='onhover_change' {...getTableBodyProps()} id="svg_tbody">
                          {/* {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()} className="text-center">
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })} */}

                          {page.map((row) => {
                            prepareRow(row);
                            return (
                              <tr {...row.getRowProps()}>
                                {row.cells.map((cell) => {
                                  return (
                                    <td
                                      {...cell.getCellProps()}
                                      // className="text-start"
                                      className={
                                  (cell.column.Header == "SMS count" ||
                                    cell.column.Header == "Sender Id" ||cell.column.Header == "Id"
                                    ||
                                   cell.column.Header=="Total sms"
                                     ) ?
                                  "text-end update_td" 
                                  :
                                  (cell.column.Header=="Action" ||
                                  cell.column.Header=="Unicode" ||
                                  cell.column.Header ==
                                                  "Camp Type" ||
                                   cell.column.Header=="Status"
                                

                                   ) ?
                                   "text-center update_td ":
                                  "text-start update_td"
                                }    
                                    >
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            );
                          })}
                        </tbody>
                        {/* <tfoot>
          {footerGroups.map((footerGroup) => (
            <tr {...footerGroup.getFooterGroupProps()}>
              {footerGroup.headers.map((column) => (
                <td className="text-center" {...column.getFooterProps}>
                  {column.render("Footer")}
                </td>
              ))}
            </tr>
          ))}
        </tfoot> */}
                      </table>
                        {/* </div>
                      </div> */}
                    </div>

                    <div className="d-flex justify-content-between mt-3">
                      <div>
                        <span>
                          Page:
                          <strong>
                            {data1?.pageable?.pageNumber + 1} of{" "}
                            {data1?.totalPages}
                          </strong>
                        </span>
                      </div>


                      <div className="prev_next d-flex align-items-center">
                <button
                      className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root m-0"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      //  disabled={data1?.pageable?.pageNumber == 0}
                      onClick={() => {
                       
                        setTableStatus({
                          ...TableStatus,
                          pageNo:0,
                        });
                        setPaginationPage(1)
                      }}
                    >
                      First
                    </button>

                <Stack spacing={2}>
              <Pagination
                onChange={(event, value) => {
                  console.log("va--", value);
                  setTableStatus({
                    ...TableStatus,
                    pageNo: Number(value) - 1,
                  });
                  setPaginationPage(value);
                  setStoppedFunState(false);

                }}
                page={paginationPage}
                count={data1 ? data1?.totalPages : ""}
               
                variant="outlined"
                shape="rounded"
                
            color="primary"
              />
            </Stack>
            <button
                      className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root ms-2"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      // disabled={
                      //   data1?.totalPages == data1?.pageable?.pageNumber + 1
                      //  }
                      onClick={() => {
                        // alert("gg")
                        setTableStatus({
                          ...TableStatus,
                          pageNo:data1?.totalPages -1 ,
                        });
                        setPaginationPage(data1?.totalPages)

                      }}
                    >
                      Last
                    </button>
                
              </div>


                      {/* <div className="btn_n800">
                        <button
                          className="btn btn_primary "
                          type="button"
                          style={{ background: "#2C97D4" }}
                          disabled={data1?.pageable?.pageNumber == 0}
                          onClick={() => {
                            setTableStatus({
                              ...TableStatus,
                              pageNo: TableStatus.pageNo - 1,
                            });
                            setStoppedFunState(false);
                          }}
                        >
                          Prev
                        </button>

                        <button
                          className="btn btn_primary ms-2"
                          type="button"
                          style={{ background: "#2C97D4" }}
                          disabled={
                            data1?.totalPages == data1?.pageable?.pageNumber + 1
                          }
                          onClick={() => {
                            setTableStatus({
                              ...TableStatus,
                              pageNo: TableStatus.pageNo + 1,
                            });
                            setStoppedFunState(false);
                          }}
                        >
                          Next
                        </button>
                      </div> */}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      ) : (
        <>
        
          {/* <div className="text-center mt-4">
                        {data?.length == 0 &&
                        open == true ? null : data?.length == 0 &&
                          open == undefined ? null : (
                          <div className="text-center">
                            <h5>No Record Found..!!</h5>
                          </div>
                        )}
                      </div> */}

                      <div className="text-center mt-4">
            {data?.length == 0 && open1 ? null : (
              <div className="text-center">
                <h5>No Record Found..!!</h5>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
